import { jwtDecode } from "jwt-decode"
export const sugarMillSubmit =  (items) => {
    const token = sessionStorage.getItem("token")
    const user = jwtDecode(token)
    
    //Alert if the file is empty.
    if(items.length === 0){
        alert("Please select at least one item.")
        return
    }

    for(let i = 0; i < items.length; i++){

        items[i].product_id = "2"
        items[i].product = "Sugar"
        items[i].by_product_id ="16"
        items[i].by_product = "sugar_mills"

        if(items[i].date){
            items[i].date = new Date(items[i].date)
        }

        //Seller check: if availbale then add this
        if (items[i].province_id) {
            items[i].province_id = Number(items[i].province_id);
        }
        
        if (items[i].province) {
            items[i].province = String(items[i].province);
        }

        if (items[i].lcu_id) {
            items[i].lcu_id = String(items[i].lcu_id);
        }
        
        if (items[i].district_id) {
            items[i].district_id = String(items[i].district_id);
        }

        if(items[i].station_id){
            items[i].station_id = String(items[i].station_id);
        }

        if(items[i].station){
            items[i].station = String(items[i].station);
        }

        if(items[i].minimum){
            items[i].minimum = Number(items[i].minimum);
        }

        if(items[i].maximum){
            items[i].maximum = Number(items[i].maximum);
        }
        //Check if quality type is there or not
        if(items[i].mill_id){
            items[i].mill_id = Number(items[i].mill_id)
        }

        //Check if deal_type exists
        if(items[i].mill_name){
            items[i].mill_name = String(items[i].mill_name)
        }

        //Append the username who has uploaded.
        items[i].user_name = user.userName       
    }
   // console.log(items[0])
    return items
}
